/**
 * decant-advantage-property
 *
 * Ecoute l'evenement "variant:update" du theme (declenche a chaque changement
 * de variante sans rechargement de page) et met a jour la line item property
 * cachee "_decant_code" en consequence :
 *  - si la nouvelle variante selectionnee possede un code (data-codes), on
 *    active le champ cache et on lui donne cette valeur ;
 *  - sinon, on desactive le champ (un champ desactive n'est jamais envoye
 *    avec le formulaire, donc aucune propriete n'est transmise).
 *
 * Generique : ne contient aucun nom de parfum, aucune valeur codee en dur.
 */
class DecantAdvantageProperty extends HTMLElement {
  connectedCallback() {
    this._codes = {};
    try {
      this._codes = JSON.parse(this.dataset.codes || '{}');
    } catch (e) {
      this._codes = {};
    }

    this._input = this.querySelector('input[name="properties[_decant_code]"]');

    this._onVariantUpdate = this._onVariantUpdate.bind(this);
    document.addEventListener('variant:update', this._onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this._onVariantUpdate);
  }

  _onVariantUpdate(event) {
    const resource = event && event.detail && event.detail.resource;
    if (!resource || !resource.id) return;

    const variantId = String(resource.id);
    const code = this._codes[variantId];

    if (!this._input) return;

    if (code) {
      this._input.value = code;
      this._input.disabled = false;
    } else {
      this._input.value = '';
      this._input.disabled = true;
    }
  }
}

if (!customElements.get('decant-advantage-property')) {
  customElements.define('decant-advantage-property', DecantAdvantageProperty);
}
